import React from 'react'

const MessagePage = () => {
  return (
    <a href="https://codegramxcodechat.onrender.com/">Go to CodeChat</a>
  )
}

export default MessagePage
